interface StarRatingProps {
  rating: number;
  max?: number;
  size?: 'sm' | 'md';
}

export default function StarRating({ rating, max = 5, size = 'sm' }: StarRatingProps) {
  const iconSize = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <span className={`inline-flex items-center gap-0.5 ${iconSize}`} aria-label={`评分 ${rating}/${max}`}>
      {Array.from({ length: max }, (_, i) => (
        <i
          key={i}
          className={`${i < Math.floor(rating) ? 'ri-star-fill text-primary-500' : i < rating ? 'ri-star-half-fill text-primary-500' : 'ri-star-fill text-background-300'}`}
        ></i>
      ))}
      <span className="ml-1 text-foreground-500 font-medium">{rating}</span>
    </span>
  );
}